package xim.poc.game.configuration.v0.behaviors

import xim.poc.game.ActorState
import xim.poc.game.configuration.SkillApplierHelper
import xim.poc.game.configuration.constants.*
import xim.poc.game.configuration.v0.V0AbilityCost
import xim.poc.game.event.Event
import xim.resource.AbilityCost
import xim.resource.AbilityCostType

class MobMarolithBehavior(actorState: ActorState): FamilyMarolithBehavior(actorState) {

    private val skills = listOf(mskillMetamorphicBlast_2671, mskillEnervatingGrasp_2672, mskillOrogenicStorm_2673, mskillSubduction_2674)

    private val skillQueue = ArrayList<SkillId>()

    override fun wantsToUseSkill(): Boolean {
        return actorState.getTpp() > 0.5f
    }

    override fun getSkills(): List<SkillId> {
        if (skillQueue.isEmpty()) {
            skillQueue += skills.shuffled().take(3)
        }

        return listOf(skillQueue.first())
    }

    override fun getSkillCostOverride(skill: SkillId): V0AbilityCost {
        return V0AbilityCost(baseCost = AbilityCost(type = AbilityCostType.Tp, value = 0))
    }

    override fun onSkillExecuted(primaryTargetContext: SkillApplierHelper.TargetEvaluatorContext): List<Event> {
        skillQueue.removeFirstOrNull()
        if (skillQueue.isEmpty()) { actorState.setTp(0) }
        return super.onSkillExecuted(primaryTargetContext)
    }

}